export const ADD_TO_DO = 'ADD_TO_DO'

export const addToDo = (text) => ({
  type: ADD_TO_DO,
  text,
})

export const REMOVE_TO_DO = 'REMOVE_TO_DO'

export const removeToDo = (id) => ({
  type: REMOVE_TO_DO,
  id,
})

export const INCREMENT_COUNTER = 'INCREMENT_COUNTER'

export const incrementCounter = () => ({
  type: INCREMENT_COUNTER,
})
